import axios from 'axios';

Vue.component('onboarding-notes', {
    props: [
        'client',
    ],

    data () {
        return {
            notes: [],

            notesForm: $.extend(true, new Form({
                data: {
                    notes: '',
                    files: null,
                    current_files: [],
                }
            }), {}),

            lastUpdatedAt: null,

            uploading: false,

            uploadProgress: 0,
        };
    },

    mounted () {
        this.fetchNotes();
    },

    methods: {
        fetchNotes () {
            axios.get(`/api/onboarding-notes/index/${this.client}`)
                .then((response) => {
                    if (response.data) {
                        this.lastUpdatedAt = response.data.updated_at;
                        this.notesForm.data.notes = response.data.notes;
                        this.notesForm.data.current_files = response.data.files;
                    }
                });
        },

        updateNotes () {
            this.uploading = true;
            this.uploadProgress = 0;

            const formData = new FormData();
            formData.append('notes', this.notesForm.data.notes);

            if (this.notesForm.data.current_files) {
                formData.append('current_files', JSON.stringify(this.notesForm.data.current_files));
            }

            if (this.notesForm.data.files) {
                Object.values(this.notesForm.data.files).forEach((file) => {
                    formData.append('files[]', file);
                });
            }

            axios
                .post(`/api/onboarding-notes/update/${this.client}`, formData, {
                    onUploadProgress: (e) => {
                        this.uploadProgress = (e.loaded / e.total) * 100;
                    }
                })
                .then(() => {
                    this.notesForm.resetForm();

                    this.uploading = false;
                    this.uploadProgress = 0;

                    this.fetchNotes();
                }).catch(() => {
                    this.uploading = false;
                    this.uploadProgress = 0;
                });
        },

        handleAddFiles (event) {
            this.notesForm.data.files = event.target.files;
        },

        deleteFile (file) {
            const c = confirm('Are you sure?');

            if (c) {
                this.notesForm.data.current_files = this.notesForm.data.current_files.filter(f => f !== file);
            }
        },
    },

    computed: {
        fileNames () {
            if (!this.notesForm.data.files) {
                return 'Select a file to attach';
            }

            const files = Object.values(this.notesForm.data.files);

            if (files.length === 0) {
                return 'Select a file to attach';
            }

            return Object.values(files).map(f => f.name).join(', ');
        }
    }
});